import React, { useState } from "react";
import logo from "../img/logo.png";
import {
  PUBLIC_NAV_ITEMS,
} from "./adminTabsConfig";

const Sidebar = ({
  username,
  role,
  activeTab,
  handleTabClick,
  isSidebarOpen,
  setIsSidebarOpen,
  onLogout,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const navItems = role === "staff"
    ? PUBLIC_NAV_ITEMS.filter((item) => item.id === "orders")
    : PUBLIC_NAV_ITEMS;

  const navButtonClass = (isActive) =>
    `flex w-full items-center rounded-xl text-left text-sm font-medium transition-all duration-200 ${
      isCollapsed ? "justify-center px-3 py-3" : "gap-3 px-4 py-3"
    } ${
      isActive
        ? "bg-emerald-500/15 text-emerald-400 ring-1 ring-emerald-500/30"
        : "text-slate-300 hover:bg-slate-800 hover:text-white"
    }`;

  return (
    <>
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <aside
        className={`fixed inset-y-0 left-0 z-40 flex h-screen flex-col overflow-hidden bg-slate-900 text-white shadow-2xl transition-all duration-300 lg:static lg:translate-x-0 ${
          isCollapsed ? "w-24" : "w-52"
        } ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* HEADER */}
        <div
          className={`shrink-0 border-b border-slate-800 ${
            isCollapsed ? "px-3 py-4" : "px-5 py-5"
          }`}
        >
          <div className="flex items-start justify-between gap-3">
            <div
              className={`flex min-w-0 items-center ${
                isCollapsed ? "justify-center w-full" : "gap-3"
              }`}
            >
              <img
                src={logo}
                alt="Logo"
                className="h-10 w-10 rounded-lg object-contain"
              />

              {!isCollapsed && (
                <div className="min-w-0">
                  <h1 className="truncate text-xl font-bold tracking-tight">
                    Dee Delicious
                  </h1>
                  <p className="text-[10px] uppercase tracking-widest font-bold text-slate-500">
                    Admin Portal
                  </p>
                </div>
              )}
            </div>

            {!isCollapsed && (
              <div className="flex items-center gap-2">
                <button title="Action"
                  onClick={() => setIsCollapsed(true)}
                  className="hidden rounded-lg border border-slate-700 px-2 py-1 text-slate-400 transition hover:bg-slate-800 hover:text-white lg:block"
                >
                  <i className="fas fa-angle-left"></i>
                </button>

                <button
                  onClick={() => setIsSidebarOpen(false)}
                  className="text-slate-400 hover:text-white lg:hidden"
                >
                  ✕
                </button>
              </div>
            )}

            {isCollapsed && (
              <button title="Action"
                onClick={() => setIsCollapsed(false)}
                className="absolute right-3 top-4 hidden rounded-lg border border-slate-700 px-2 py-1 text-slate-400 transition hover:bg-slate-800 hover:text-white lg:block"
              >
                <i className="fas fa-angle-right"></i>
              </button>
            )}
          </div>
        </div>

        {/* NAV AREA */}
        <div className="flex-1 overflow-y-auto px-3 py-6 sidebar-scrollbar">
          <div className="space-y-2">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleTabClick(item.id)}
                className={navButtonClass(activeTab === item.id)}
                title={isCollapsed ? item.label : ""}
              >
                <span className={`${isCollapsed ? "text-lg" : "text-sm w-5 text-center"}`}>
                  {item.icon}
                </span>
                {!isCollapsed && <span>{item.label}</span>}
              </button>
            ))}
          </div>
        </div>

        {/* FOOTER - LOGOUT SECTION */}
        <div className="border-t border-slate-800 p-4">
          <button
            onClick={onLogout}
            className={`group flex w-full items-center justify-center rounded-xl px-4 py-3 text-sm font-semibold transition-all duration-200 border border-red-500/60 bg-slate-900 text-red-400 hover:bg-red-600 hover:text-white hover:border-red-600 ${
              isCollapsed ? "" : "gap-3"
            }`}
            title="Logout"
          >
            <span className={`${isCollapsed ? "text-lg" : "text-sm w-5 text-center"}`}>
              ↩
            </span>
            {!isCollapsed && (
               <span>Logout</span>
            )}
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
